import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import GlobalTopBar from './GlobalTopBar';
import CommandPalette from '../command/CommandPalette';
import { useThemeStore } from '../../state/themeStore';

export default function GlobalShell() {
  const isDarkMode = useThemeStore((s) => s.isDarkMode);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Toaster richColors position="top-center" theme={isDarkMode ? 'dark' : 'light'} />
      <GlobalTopBar />
      <Outlet />
      <CommandPalette />
    </div>
  );
}
